import { type PropsWithChildren, forwardRef } from "react";

import type { AvatarProps } from "./Avatar.types";
import { cn } from "$/lib/utils/functions/misc.functions";

const Avatar = forwardRef<HTMLImageElement, PropsWithChildren<AvatarProps>>(
  ({ size = "large", ...avatarProps }, forwardedRef) => {
    return (
      <img
        ref={forwardedRef}
        className={cn("rounded-lg", {
          "h-12 w-12": size === "large",
          "h-16 w-16": size === "extraLarge",
        })}
        {...avatarProps}
      />
    );
  },
);

Avatar.displayName = "Avatar";

export default Avatar;
